package org.catharsis.spendtel.feature.presentation.financialgoal

import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.outlined.AccountBalanceWallet
import androidx.compose.material.icons.outlined.Assessment
import androidx.compose.material.icons.outlined.CreditCard
import androidx.compose.material.icons.outlined.FlightTakeoff
import androidx.compose.material.icons.outlined.Psychology
import androidx.compose.material.icons.outlined.Shield
import androidx.compose.material.icons.outlined.TrackChanges
import androidx.compose.material.icons.outlined.TrendingDown
import androidx.compose.material.icons.outlined.TrendingUp
import androidx.compose.ui.graphics.vector.ImageVector
import org.catharsis.spendtel.feature.data.FinancialGoal

fun FinancialGoal.icon(): ImageVector {
    return when (this) {
        FinancialGoal.SaveMore -> Icons.Outlined.AccountBalanceWallet
        FinancialGoal.PayOffDebt -> Icons.Outlined.CreditCard
        FinancialGoal.EmergencyFund -> Icons.Outlined.Shield
        FinancialGoal.ReduceSpending -> Icons.Outlined.TrendingDown
        FinancialGoal.UnderstandHabits -> Icons.Outlined.Psychology
        FinancialGoal.BigPurchase -> Icons.Outlined.FlightTakeoff
        FinancialGoal.InvestMore -> Icons.Outlined.TrendingUp
        FinancialGoal.StickToBudget -> Icons.Outlined.Assessment
    }
}

val financialGoalHeroIcon: ImageVector = Icons.Outlined.TrackChanges
